import { render, staticRenderFns } from "./FieldSetAdminRulesDetail.vue?vue&type=template&id=754b92e1&scoped=true"
import script from "./FieldSetAdminRulesDetail.vue?vue&type=script&lang=js"
export * from "./FieldSetAdminRulesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b92e1",
  null
  
)

export default component.exports